(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const olahouFadeLayers = new WeakMap();

  function olahouImageFade(event) {
    if (event.pointerType !== 'mouse') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const gallery = event.target;
    if (!(gallery instanceof HTMLElement)) return;
    if (!gallery.matches('.card-gallery[on\\:pointerenter]')) return;

    olahouFadeLayers.get(gallery)?.remove();

    const slide = gallery.querySelector(
      'slideshow-slide[aria-hidden="false"]'
    );
    const original = slide?.querySelector('img');

    if (!original?.complete || !original.naturalWidth) return;

    const bounds = original.getBoundingClientRect();
    const container = gallery.getBoundingClientRect();
    const styles = getComputedStyle(original);
    const overlay = document.createElement('img');

    overlay.src = original.currentSrc || original.src;
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');

    Object.assign(overlay.style, {
      position: 'absolute',
      left: `${bounds.left - container.left - gallery.clientLeft}px`,
      top: `${bounds.top - container.top - gallery.clientTop}px`,
      width: `${bounds.width}px`,
      height: `${bounds.height}px`,
      maxWidth: 'none',
      objectFit: styles.objectFit,
      objectPosition: styles.objectPosition,
      borderRadius: styles.borderRadius,
      pointerEvents: 'none',
      zIndex: '2',
      opacity: '1'
    });

    gallery.appendChild(overlay);
    olahouFadeLayers.set(gallery, overlay);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!overlay.isConnected) return;

        const animation = overlay.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          {
            duration: 150,
            easing: 'ease-in-out',
            fill: 'forwards'
          }
        );

        animation.finished.then(() => {
          overlay.remove();
          if (olahouFadeLayers.get(gallery) === overlay) {
            olahouFadeLayers.delete(gallery);
          }
        });
      });
    });
  }

  window.addEventListener('pointerenter', olahouImageFade, true);
  window.addEventListener('pointerleave', olahouImageFade, true);
  } catch(e) { console.error(e); }
})();

})();
